let deferred = false;

export function setSessionDeferred(value: boolean): void {
  deferred = value;
}

export function isSessionDeferred(): boolean {
  return deferred;
}
